import { TypeofFavoriteLinesViewType } from "@/types";
import {
  IServiceInfo,
  ISignupInfo,
  IColor,
  ITwcConfig,
  IAppPermissions,
  ILinePathMapInfo,
  IBusStopLayout,
  ICampaign,
} from "./serviceInfo.types";
import { ITermsInfo } from "./termsInfo";

export class ServiceInfo implements IServiceInfo {
  readonly id: string;
  readonly name: string;
  readonly welcomeMessages: string[][];
  readonly favorieLinesViewType: TypeofFavoriteLinesViewType;
  readonly catchPhrases: string[];
  readonly signupInfos?: ISignupInfo[];
  readonly shouldShowBoardLog?: boolean;
  readonly shouldShowBookLog?: boolean;
  readonly shouldShowPayLog?: boolean;
  readonly shouldShowLostAndFound?: boolean;
  readonly shouldShowTurnList?: boolean;
  readonly shouldShowRemainBookCount: boolean;
  readonly shouldShowTurnPath: boolean;
  readonly isManagerCertRequired: boolean;
  readonly isPublicLineApi: boolean;
  readonly isPublicTalkApi: boolean;
  readonly passwordChangeCycleDays: number;
  readonly passwordChangeAlarmIntervalDay: number;
  readonly twcConfig: ITwcConfig;
  readonly logoPath: string;
  readonly bookTimeoutIntervalMin?: number;
  readonly certValidIntervalMin?: number;
  readonly lastBusStopArrivalThresholdMin: number;
  readonly bookWaitYn?: boolean;
  readonly boardCheckCode?: string;
  readonly color?: IColor;
  readonly appPermissions?: IAppPermissions;
  readonly termsList: ITermsInfo[];
  readonly agreeCodes: ITermsInfo[];
  readonly whiteListDomains?: string[];
  readonly linePathMapInfo: ILinePathMapInfo;
  readonly displayBlockDtmYn: boolean;
  readonly maxDailyTalkCreationCount?: number;
  readonly maxDailyVocCreationCount?: number;
  readonly maxDailyLostFoundCreationCount?: number;
  readonly busStopLayouts?: IBusStopLayout[];
  readonly verificationGuideImageUrl?: string;
  readonly passwordNextChangeLimit: number;
  readonly lostAndFoundGuideUrl?: string;
  readonly busLocationUpdateIntervalMillis?: number;
  readonly onBoardRequestIntervalMillis: number;
  readonly lineSortOrder?: string;
  readonly campaigns?: ICampaign[];
  readonly csCenterPhone?: string;
  readonly busCompanyListImageUrl?: string;
  readonly busCompanyUrl?: string;
  readonly lineCacheTtlMin?: number;
  readonly favoriteLinesSortOrder?: string;

  constructor(data: IServiceInfo) {
    this.id = data.id;
    this.name = data.name;
    this.welcomeMessages = data.welcomeMessages;
    this.favorieLinesViewType = data.favorieLinesViewType;
    this.catchPhrases = data.catchPhrases;
    this.signupInfos = data.signupInfos;
    this.shouldShowBoardLog = data.shouldShowBoardLog;
    this.shouldShowBookLog = data.shouldShowBookLog;
    this.shouldShowPayLog = data.shouldShowPayLog;
    this.shouldShowLostAndFound = data.shouldShowLostAndFound;
    this.shouldShowTurnList = data.shouldShowTurnList;
    this.shouldShowTurnPath = data.shouldShowTurnPath;
    this.shouldShowRemainBookCount = data.shouldShowRemainBookCount;
    this.isManagerCertRequired = data.isManagerCertRequired;
    this.isPublicLineApi = data.isPublicLineApi;
    this.isPublicTalkApi = data.isPublicTalkApi;
    this.passwordChangeCycleDays = data.passwordChangeCycleDays;
    this.passwordChangeAlarmIntervalDay = data.passwordChangeAlarmIntervalDay;
    this.passwordNextChangeLimit = data.passwordNextChangeLimit;
    this.twcConfig = data.twcConfig;
    this.logoPath = data.logoPath;
    this.bookTimeoutIntervalMin = data.bookTimeoutIntervalMin;
    this.certValidIntervalMin = data.certValidIntervalMin;
    this.bookWaitYn = data.bookWaitYn;
    this.boardCheckCode = data.boardCheckCode;
    this.color = data.color;
    this.appPermissions = data.appPermissions;
    this.termsList = data.termsList;
    this.agreeCodes = data.agreeCodes;
    this.whiteListDomains = data.whiteListDomains;
    this.linePathMapInfo = data.linePathMapInfo;
    this.displayBlockDtmYn = data.displayBlockDtmYn;
    this.maxDailyTalkCreationCount = data.maxDailyTalkCreationCount;
    this.maxDailyVocCreationCount = data.maxDailyVocCreationCount;
    this.maxDailyLostFoundCreationCount = data.maxDailyLostFoundCreationCount;
    this.lastBusStopArrivalThresholdMin = data.lastBusStopArrivalThresholdMin;
    this.busStopLayouts = data.busStopLayouts;
    this.verificationGuideImageUrl = data.verificationGuideImageUrl;
    this.lostAndFoundGuideUrl = data.lostAndFoundGuideUrl;
    this.busLocationUpdateIntervalMillis = data.busLocationUpdateIntervalMillis;
    this.onBoardRequestIntervalMillis = data.onBoardRequestIntervalMillis;
    this.lineSortOrder = data.lineSortOrder;
    this.campaigns = data.campaigns;
    this.csCenterPhone = data.csCenterPhone;
    this.busCompanyListImageUrl = data.busCompanyListImageUrl;
    this.busCompanyUrl = data.busCompanyUrl;
    this.lineCacheTtlMin = data.lineCacheTtlMin;
    this.favoriteLinesSortOrder = data.favoriteLinesSortOrder;
  }
}
